import { render, staticRenderFns } from "./document-list.vue?vue&type=template&id=134cc45c&scoped=true"
import script from "./document-list.vue?vue&type=script&lang=js"
export * from "./document-list.vue?vue&type=script&lang=js"
import style0 from "./document-list.vue?vue&type=style&index=0&id=134cc45c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cc45c",
  null
  
)

export default component.exports